<div class="upload-progress-container">
  @if(currentStep === 5){
  <!--  -->
  @if(!runCoaMappingLoading){
  <app-custom-motif-uploader
    [file]="coaMappingFile"
    [dropMessage]="'Optionally, Click to upload or drag and drop'"
    (fileEmitter)="onCoaMappingFileUpload($event)"
    (fileHasError)="onCoaMappingFileHasErrorHasError($event)"
  ></app-custom-motif-uploader>
  } @if(runCoaMappingLoading){
  <div class="progressbar-container">
    <motif-progress-bar
      [circle]="true"
      [showLabel]="true"
      [customLabel]="true"
      [tabIndex]="0"
      aria-label="Loading. Level 1 of Chart of Account Mapping in progress..."
      aria-live="polite"
    ></motif-progress-bar>
    <p progressbar-label>Level 1 of Chart of Account Mapping in progress...</p>

    <p
      class="cancel-run"
      [tabIndex]="0"
      (click)="cancelLatestMappingRun()"
      (keydown.enter)="cancelLatestMappingRun()"
    >
      Cancel
    </p>
  </div>
  }

  <div class="buttons-container">
    <button
      motifButton
      color="primary-alt"
      [disabled]="runCoaMappingLoading"
      (click)="goBackToAgentOne()"
      [ariaLabel]="'Go back to step' + (currentStep - 1)"
      aria-live="assertive"
    >
      Go back
    </button>

    <button
      motifButton
      color="primary"
      [disabled]="runCoaMappingLoading || coaMappingFileHasError"
      (click)="runLatestMapping()"
      aria-label="Run Chart of Account Mapping"
      aria-live="assertive"
    >
      Run
    </button>
  </div>
  }
  <!--  -->
  @if(currentStep === 6){
  <div class="process-message-container" *ngIf="stepFiveDuration">
    <motif-icon
      [iconFunction]="IconoirCheckCircle"
      size="20"
      class="success-check"
    ></motif-icon>
    <p class="step-duration-message">{{ stepFiveDuration }}</p>
  </div>

  <app-custom-motif-downloader
    [filename]="coaMappedFileToDownload.filename"
    [fileId]="coaMappedFileToDownload.id"
    [fileSize]="coaMappedFileToDownload.file_size"
  ></app-custom-motif-downloader>

  <div class="buttons-container">
    <button
      motifButton
      color="primary-alt"
      (click)="goToPreviousStep_5()"
      [ariaLabel]="'Go back to step' + (currentStep - 1)"
      aria-live="assertive"
    >
      Go back
    </button>
    <button
      motifButton
      color="primary"
      (click)="goToNextStep(true)"
      aria-label="Go to Next step"
      aria-live="assertive"
    >
      Next
    </button>
  </div>
  }
  <!---->
  @if(currentStep === 7){
  <!---->
  @if(!runCoAFinalMapLoading){
  <app-custom-motif-uploader
    [file]="coaFinalMappingFile"
    [dropMessage]="'Optionally, Click to upload or drag and drop'"
    (fileEmitter)="onCoaFinalMappingFileUpload($event)"
    (fileHasError)="onCoaFinalMappingFileFileHasError($event)"
  ></app-custom-motif-uploader>
  } @if(runCoAFinalMapLoading){
  <div class="progressbar-container">
    <motif-progress-bar
      [circle]="true"
      [showLabel]="true"
      [customLabel]="true"
      [tabIndex]="0"
      aria-label="Loading. Chart of Account Mapping in progress..."
      aria-live="polite"
    ></motif-progress-bar>
    <p progressbar-label>Chart of Account Mapping in progress...</p>

    <p
      class="cancel-run"
      [tabIndex]="0"
      (click)="cancelValidatedMappingRun()"
      (keydown.enter)="cancelValidatedMappingRun()"
    >
      Cancel
    </p>
  </div>
  }

  <div class="buttons-container">
    <button
      motifButton
      color="primary-alt"
      [disabled]="runCoAFinalMapLoading"
      (click)="goToPreviousStep(true)"
      [ariaLabel]="'Go back to step' + (currentStep - 1)"
      aria-live="assertive"
    >
      Go back
    </button>
    <button
      motifButton
      color="primary"
      [disabled]="runCoAFinalMapLoading || coaFinalMappingFileFileHasError"
      (click)="runValidatedMapping()"
      [ariaLabel]="'Continue to step' + (currentStep + 1)"
      aria-live="assertive"
    >
      Continue
    </button>
  </div>
  } @if(currentStep === 8){
  <div class="process-message-container" *ngIf="stepSevenDuration">
    <motif-icon
      [iconFunction]="IconoirCheckCircle"
      size="20"
      class="success-check"
    ></motif-icon>
    <p class="step-duration-message">{{ stepSevenDuration }}</p>
  </div>

  <app-custom-motif-downloader
    [filename]="coaFinalMappedFileToDownload.filename"
    [fileId]="coaFinalMappedFileToDownload.id"
    [fileSize]="coaFinalMappedFileToDownload.file_size"
  ></app-custom-motif-downloader>

  <div class="buttons-container">
    <button
      motifButton
      color="primary-alt"
      (click)="goToPreviousStep(true)"
      [ariaLabel]="'Go back to step' + (currentStep - 1)"
      aria-live="assertive"
    >
      Go back
    </button>
  </div>
  }
</div>
